import React from "react";

const Organisational  = () => {
  return (
    <div className="w-full h-screen">
      <iframe
  src="https://nk.lifecommando.in/widget/form/fY4gaJ7yjGqlGJzgWTqU"
  style={{ width: "100%", height: "100%", border: "none",borderRadius: "3px" }}
  id="inline-fY4gaJ7yjGqlGJzgWTqU" 
  data-layout="{'id':'INLINE'}"
  data-trigger-type="alwaysShow"
  data-trigger-value=""
  data-activation-type="alwaysActivated"
  data-activation-value=""
  data-deactivation-type="neverDeactivate"
  data-deactivation-value=""
  data-form-name="Institutional (Annual) Membership  Details "
  data-height="3743"
  data-layout-iframe-id="inline-fY4gaJ7yjGqlGJzgWTqU"
  data-form-id="fY4gaJ7yjGqlGJzgWTqU"
  title="Institutional (Annual) Membership  Details "
      >
</iframe>
<script src="https://nk.lifecommando.in/js/form_embed.js"></script>
    </div>
  );
};

export default Organisational ;
